import { Content } from '@prismicio/client';
import type { Simplify } from '../../../prismicio-types';

import { JSX } from 'react';
import {
  AboutUsHero,
  ConsolidationLoansHero,
  HelocHero,
  HomePageHero,
  LoanUsesHero,
  OurClientsHero,
  OurProcessHero,
  PersonalLoansHero,
} from './parts';
import { HeroData, HeroVariation } from './types';
import { ProspectData } from '@/types/salesforce';

export const HeroSlice = ({
  variation,
  data,
  prospect,
}: {
  variation: HeroVariation;
  data: HeroData;
  prospect?: ProspectData;
}): JSX.Element | null => {
  switch (variation) {
    case HeroVariation.HomePage:
      return (
        <HomePageHero
          data={data as Simplify<Content.HeroSliceDefaultPrimary>}
        />
      );

    case HeroVariation.ConsolidationLoans:
      return (
        <ConsolidationLoansHero
          data={data as Simplify<Content.HeroSliceConsolidationLoansPrimary>}
        />
      );

    case HeroVariation.PersonalLoans:
      return (
        <PersonalLoansHero
          data={data as Simplify<Content.HeroSlicePersonalLoansPrimary>}
        />
      );

    case HeroVariation.Heloc:
      return (
        <HelocHero data={data as Simplify<Content.HeroSliceHelocPrimary>} />
      );
    case HeroVariation.OurClients:
      return (
        <OurClientsHero
          data={data as Simplify<Content.HeroSliceOurClientsPrimary>}
        />
      );

    case HeroVariation.LoanUses:
      return (
        <LoanUsesHero
          data={data as Simplify<Content.HeroSliceLoanUsesPrimary>}
        />
      );

    case HeroVariation.OurProcess:
      return (
        <OurProcessHero
          data={data as Simplify<Content.HeroSliceOurProcessPrimary>}
        />
      );
    case HeroVariation.AboutUs:
      return (
        <AboutUsHero data={data as Simplify<Content.HeroSliceAboutUsPrimary>} />
      );
    case HeroVariation.EngineLanding:
      return (
        <HomePageHero
          data={data as Simplify<Content.HeroSliceDefaultPrimary>}
          prospect={prospect}
        />
      );
    default:
      break;
  }
  return null;
};
